module.exports = __webpack_public_path__ + "img/logo-opb-veda.0f3e7eb8.png";